<template>
    <div>
        <div v-for="(item, index) in hotsitem" :style="getCustomStyle(item)" :key="index" class="custom-hot_item"
            @click.stop="actionHandler(item.action)"></div>
    </div>
</template>

<script>

import actionMixins from "@/utils/action.mixins";

export default {
    name: 'HotItem',
    mixins: [actionMixins],
    props: {
        hotsitem: {
            type: Array,
            required: true,
        },
        type: {
            type: String,
            required: true,
        }
    },
    data() {
        return {

        }
    },
    computed: {
        winW() { return window.innerWidth > 1024; },
    },
    methods: {
        getCustomStyle(item) {
            const { width, height, x, y } = item;
            let _radio = 1200 / 1200;
            if (this.type === 'h5') {
                _radio = window.innerWidth / 750;
            }
            let _style = {
                width: width * _radio + 'px',
                height: height * _radio + 'px',
                top: y * _radio + 'px',
                left: x * _radio + 'px',
            }
            return _style;
        }
    }
}

</script>

<style lang="scss" scoped>
.custom-hot_item {
    position: absolute;
    z-index: 2;
    // background: rgba(255, 255, 255, 0.5);
    cursor: pointer;
}
</style>